import React, { useState } from "react";
import { Avatar, Card, Grid, Icon, InputText, Link, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { RoutesEnum } from "~/types/enums";
import { useHistory } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { useSelector } from "react-redux";
import authSelectors from "~/store/auth/selectors";
const StyledGrid = styled(Grid)`
  max-height: 300px;
  overflow: auto;
`;
const TopicSummaryContributorsCard = _ref => {
  let {
    contributors,
    initialLimit = 3,
    ...rest
  } = _ref;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [limit, setLimit] = useState(initialLimit);
  const [query, setQuery] = useState("");
  const user = useSelector(authSelectors.getUser);
  let tempContributors = contributors.sort((a, b) => b.footprintCount - a.footprintCount);
  if (!tempContributors.length) {
    return null;
  }
  const exceededLimit = tempContributors.length > initialLimit;
  const exceededLimitBy = limit && tempContributors.length > limit ? tempContributors.length - limit : undefined;
  if (exceededLimitBy) {
    tempContributors = tempContributors.slice(0, limit);
  }
  const toggleLimit = () => {
    setLimit(prev => prev ? undefined : initialLimit);
    setQuery("");
  };
  const handleMemberClick = id => {
    history.push(user.id === id ? RoutesEnum.PROFILE : RoutesEnum.MEMBER.replace(":memberId", id));
  };
  const filteredContributors = tempContributors.filter(_ref2 => {
    let {
      firstName,
      lastName
    } = _ref2;
    return query === "" || `${firstName} ${lastName}`.toLowerCase().includes(query.toLowerCase());
  });
  return /*#__PURE__*/React.createElement(Card, rest, exceededLimit && !exceededLimitBy && /*#__PURE__*/React.createElement(InputText, {
    autoFocus: true,
    value: query,
    onChange: val => setQuery(val),
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: "search",
      s: {
        mr: 2
      }
    }),
    placeholder: t("common.actions.search"),
    fullWidth: true,
    clearButton: true,
    s: {
      mb: 4
    }
  }), filteredContributors.length ? /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 3,
    gap: 4,
    template: "2.3rem 1fr"
  }, filteredContributors.map(contributor => {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: contributor.id
    }, /*#__PURE__*/React.createElement(Avatar, {
      user: contributor,
      size: 9
    }), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Link, {
      onClick: () => handleMemberClick(contributor.id),
      fontSize: 4,
      weight: "semiBold",
      color: colors.text.primary,
      display: "block"
    }, contributor.firstName, " ", contributor.lastName), /*#__PURE__*/React.createElement(Text, {
      color: "textSecondary",
      weight: "semiBold"
    }, t("TopicSummaryCard.footprints", {
      count: contributor.footprintCount
    }))));
  })) : /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold",
    fontSize: 4,
    s: {
      my: 2
    }
  }, "No contributors"), exceededLimit && /*#__PURE__*/React.createElement(Link, {
    onClick: toggleLimit,
    s: {
      mt: 2
    },
    weight: "semiBold",
    color: colors.text.secondary,
    underline: true
  }, exceededLimitBy ? `Show ${exceededLimitBy} more` : "Collapse list"));
};
export default TopicSummaryContributorsCard;